<app-header></app-header>
<div class="min-h-screen pb-10">
  <div class="max-w-6xl mx-auto px-4 pt-4">
    <nav class="text-xs mb-3" style="color: var(--tx-3)">
      <a routerLink="/home">Início</a> / <span>Relatórios</span> / <span style="color: var(--tx)">Relatórios da Agenda</span>
    </nav>
    <app-relatorios-abas></app-relatorios-abas>

    <ng-template #iconeTpl let-tipo>
      <svg viewBox="0 0 24 24" width="20" height="20" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"
           [attr.data-icone]="tipo" [ngSwitch]="tipo">
        <g *ngSwitchCase="'agenda'"><rect x="3" y="5" width="18" height="16" rx="2"/><path d="M16 3v4M8 3v4M3 10h18"/><path d="M8 14h2M14 14h2M8 17h2"/></g>
        <g *ngSwitchCase="'atendimento'"><path d="M8 4H6a2 2 0 0 0-2 2v13a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V6a2 2 0 0 0-2-2h-2"/><rect x="8" y="2.5" width="8" height="3.5" rx="1"/><path d="M12 10v6M9 13h6"/></g>
        <g *ngSwitchCase="'producao'"><path d="M5 3v5a4 4 0 0 0 8 0V3"/><path d="M9 12v2a5 5 0 0 0 10 0v-1"/><circle cx="19" cy="11" r="2"/></g>
        <g *ngSwitchCase="'financeiro'"><rect x="2" y="6" width="20" height="13" rx="2"/><circle cx="12" cy="12.5" r="2.5"/><path d="M6 10v5M18 10v5"/></g>
        <g *ngSwitchCase="'notas'"><path d="M6 2h12v20l-3-2-3 2-3-2-3 2z"/><path d="M9 7h6M9 11h6M9 15h3"/></g>
        <g *ngSwitchCase="'comercial'"><path d="M3 3v18h18"/><path d="M7 15l4-4 3 3 6-6"/><path d="M15 8h5v5"/></g>
        <g *ngSwitchCase="'administrativo'"><rect x="3" y="7" width="18" height="13" rx="2"/><path d="M9 7V5a2 2 0 0 1 2-2h2a2 2 0 0 1 2 2v2"/><path d="M3 13h18"/></g>
        <g *ngSwitchCase="'outros'"><circle cx="6" cy="6" r="2"/><circle cx="18" cy="6" r="2"/><circle cx="6" cy="18" r="2"/><circle cx="18" cy="18" r="2"/></g>
        <g *ngSwitchDefault><path d="M14 3H7a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h10a2 2 0 0 0 2-2V8z"/><path d="M14 3v5h5"/><path d="M9 13h6M9 17h4"/></g>
      </svg>
    </ng-template>

    <section *ngIf="!carregando && recentesVisiveis.length" class="mb-4" aria-labelledby="titulo-recentes">
      <h2 id="titulo-recentes" class="titulo">Últimos relatórios gerados</h2>
      <div class="recentes">
        <button *ngFor="let item of recentesVisiveis; trackBy: trackRecente" type="button" class="recente" data-teste="recente"
                (click)="abrirRecente(item)" [attr.aria-label]="rotuloRecente(item)">
          <span class="icone" aria-hidden="true">
            <ng-container *ngTemplateOutlet="iconeTpl; context: { $implicit: icone(item.relatorio) }"></ng-container>
          </span>
          <span class="recente-texto">
            <span class="recente-nome">{{ item.relatorio.name }}</span>
            <span class="recente-meta">
              <span *ngFor="let f of formatos(item.relatorio)" class="selo-formato">{{ f }}</span>
              <span>{{ quando(item.recente) }}</span>
            </span>
          </span>
        </button>
      </div>
    </section>

    <section class="cartao" aria-labelledby="titulo-todos">
      <div class="cabeca">
        <h2 id="titulo-todos" class="titulo">Todos os relatórios</h2>
        <label class="campo busca">
          <span class="sr-only">Buscar relatório</span>
          <input id="busca-relatorio" type="search" autocomplete="off" placeholder="Buscar por nome ou número" [(ngModel)]="busca">
        </label>
      </div>

      <div *ngIf="carregando" class="flex flex-col gap-2" aria-busy="true">
        <div *ngFor="let s of skeleton" class="esqueleto animate-pulse"></div>
      </div>

      <div *ngIf="!carregando && erro" class="erro-caixa flex items-center gap-3">
        {{ erro }}
        <button type="button" class="btn-sec" (click)="carregar()">Tentar de novo</button>
      </div>

      <p *ngIf="!carregando && !erro && !relatorios.length" class="nota">Nenhum relatório liberado para o seu perfil.</p>
      <p *ngIf="!carregando && !erro && relatorios.length && !grupos.length" class="nota">Nenhum relatório encontrado para a busca.</p>

      <section *ngFor="let g of grupos; let i = index; trackBy: trackGrupo" class="grupo">
        <h3 class="grupo-nome">
          <button type="button" class="grupo-cabecalho" [attr.aria-expanded]="grupoAberto(g.nome)"
                  [attr.aria-controls]="'grupo-lista-' + i" (click)="alternarGrupo(g.nome)">
            <svg class="chevron" [class.aberto]="grupoAberto(g.nome)" viewBox="0 0 24 24" width="16" height="16" fill="none"
                 stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M9 6l6 6-6 6"/></svg>
            <span>{{ g.nome }} ({{ g.relatorios.length }})</span>
          </button>
        </h3>
        <div *ngIf="grupoAberto(g.nome)" class="linhas" [id]="'grupo-lista-' + i">
          <button *ngFor="let r of g.relatorios; trackBy: trackRelatorio" type="button" class="linha" [attr.data-teste]="'relatorio-' + r.id" (click)="abrir(r)">
            <span class="icone pequeno" aria-hidden="true">
              <ng-container *ngTemplateOutlet="iconeTpl; context: { $implicit: icone(r) }"></ng-container>
            </span>
            <span class="linha-texto">
              <span class="linha-num">#{{ r.id }}</span>
              <span class="linha-nome">{{ r.name }}</span>
              <span *ngFor="let f of formatos(r)" class="selo-formato">{{ f }}</span>
            </span>
            <span class="btn-acao" aria-hidden="true">Gerar</span>
          </button>
        </div>
      </section>
    </section>
  </div>
</div>

<app-relatorio-filtros *ngIf="aberto" [relatorio]="aberto" [valoresIniciais]="valoresAbertos" [gerando]="gerando"
                       [mensagem]="mensagem" [tipoMensagem]="tipoMensagem"
                       (gerar)="gerar($event)" (fechar)="fecharModal()"></app-relatorio-filtros>
